<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <v-layout>
      <v-flex>
        <v-text-field
          v-model="username"
          v-if="tipoUsuarioValue != tipoUsuarioProveedor"
          :error-messages="usernameErrors"
          label="E-mail"
          :box="tipeView == 'crear' ? false : true"
          :readonly="tipeView == 'crear' ? false : true"
          maxlength="100"
          @focusout="loadData"
          @input="$v.username.$touch()"
          @blur="tipeView == 'crear' ? $v.username.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="rut"
          v-if="tipoUsuarioValue != tipoUsuarioProveedor"
          label="RUT (12345678-K)"
          maxlength="11"
          :error-messages="rutErrors"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
          @input="$v.rut.$touch()"
          @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="rut"
          v-if="tipoUsuarioValue == tipoUsuarioProveedor"
          label="RUT (12345678-K)"
          maxlength="11"
          :error-messages="rutErrors"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
          @focusout="loadData"
          @input="$v.rut.$touch()"
          @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="username"
          v-if="tipoUsuarioValue == tipoUsuarioProveedor"
          :error-messages="usernameErrors"
          label="E-mail"
          :box="tipeView == 'crear' ? false : true"
          :readonly="tipeView == 'crear' ? false : true"
          maxlength="100"
          @input="$v.username.$touch()"
          @blur="tipeView == 'crear' ? $v.username.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="nombre"
          maxlength="50"
          :error-messages="nombreErrors"
          label="Nombre"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
          @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellido"
          :error-messages="apellidoErrors"
          label="Apellido"
          maxlength="50"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
          @input="$v.apellido.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido.$touch() : null"
        ></v-text-field>
        <v-select
          v-model="tipoUsuarioValue"
          :items="tipoUsuarioSelect"
          item-text="name"
          item-value="code"
          :error-messages="tipoSelectErrors"
          label="Tipo de usuario"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
          @change="loadRoles()"
        ></v-select>
        <v-select
          v-model="rolUsuarioValue"
          :items="rolUsuarioSelect"
          item-text="nombre"
          item-value="id"
          :error-messages="rolSelectErrors"
          label="Rol"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
          @input="$v.rolUsuarioValue.$touch()"
        ></v-select>
        <v-select
          v-if="tipoUsuarioValue != tipoUsuarioAdmin"
          v-model="periodo"
          :items="periodoSelect"
          data-vv-name="listaPeriodos"
          label="Periodo"
          @change="loadContratos()"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
        ></v-select>
        <v-select
          v-if="tipoUsuarioValue != tipoUsuarioAdmin"
          v-model="idContrato"
          :items="contratoSelect"
          item-text="codigo"
          item-value="id"
          data-vv-name="listaContratos"
          :error-messages="idContratoErrors"
          label="Contrato"
          :box="tipeView == 'consulta'"
          :readonly="tipeView == 'consulta'"
        ></v-select>
      </v-flex>
      <v-flex xs12 md6></v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        :loading="loading"
        v-if="tipeView == 'crear' || tipeView == 'modifica'"
        color="primary"
        class="mb-2"
        @click.prevent="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import axios from "axios";
import { misRoles } from "@/mixins/roles.js";

export default {
  name: "usuario-data",
  components: {},
  mixins: [misRoles, validationMixin],
  props: {},
  data() {
    return {
      tipeView: "",
      validacion: false,
      id: 0,
      rut: "",
      username: "",
      nombre: "",
      apellido: "",
      tipoUsuarioAdmin: 2,
      tipoUsuarioProveedor: 1,
      tipoUsuarioValue: null,
      tipoUsuarioSelect: [
        { name: "AGENCIA", code: 0 },
        { name: "PROVEEDOR", code: 1 },
        { name: "ADMINISTRADOR", code: 2 },
      ],
      rolUsuarioValue: null,
      rolUsuarioSelect: [],
      periodo: "",
      periodoSelect: [],
      idContrato: null,
      contratoSelect: [],
      existEnContrato: "",
      usuario: "",
      loading: false,
      rutErrors: [],
    };
  },
  validations: {
    apellido: { required, maxLength: maxLength(50) },
    rut: { maxLength: maxLength(11) },
    nombre: { required, maxLength: maxLength(50) },
    username: { required, email, maxLength: maxLength(100) },
    tipoUsuarioValue: { required },
    rolUsuarioValue: { required },
    idContrato: {
      required: requiredIf(function () {
        return this.tipoUsuarioValue != this.tipoUsuarioAdmin;
      }),
    },
  },

  created() {
    this.username = this.$route.params.username;
    this.tipeView = this.$route.params.tipeView;

    if (!this.tipeView || this.tipeView == null || this.tipeView == "") {
      this.tipeView = "crear";
    }
    if (this.tipeView == "crear") {
      this.username = "";
    }
    if (
      this.tipoUsuarioValue != this.tipoUsuarioAdmin &&
      this.tipeView != "consulta"
    ) {
      this.loadPeriodos();
      this.loadContratos();
    }

    if (this.tipeView == "consulta" || this.tipeView == "modifica") {
      this.loadData();
    }
  },

  mounted() {},
  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
    apellidoErrors() {
      const errors = [];
      if (!this.$v.apellido.$dirty) return errors;

      !this.$v.apellido.required && errors.push("Apellido es obligatorio.");
      return errors;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.email && errors.push("Debe ser un e-mail valido");
      !this.$v.username.required && errors.push("E-mail es obligatorio.");
      if (this.existEnContrato) {
        errors.push("Usuario ya existe en el contrato");
      }
      return errors;
    },

    tipoSelectErrors() {
      const errors = [];
      if (!this.$v.tipoUsuarioValue.$dirty) return errors;
      !this.$v.tipoUsuarioValue.required &&
        errors.push("Tipo usuario es obligatorio.");
      return errors;
    },
    rolSelectErrors() {
      const errors = [];
      if (!this.$v.rolUsuarioValue.$dirty) return errors;
      !this.$v.rolUsuarioValue.required &&
        errors.push("Rol usuario es obligatorio.");
      return errors;
    },

    idContratoErrors() {
      const errors = [];
      if (!this.$v.idContrato.$dirty) return errors;
      !this.$v.idContrato.required && errors.push("Contrato es obligatorio.");
      return errors;
    },
    isDisabled() {
      if (this.tipeView != "modifica" || this.tipeView != "crear") {
        return false;
      } else {
        return this.usuario != null && this.usuario != "" ? true : false;
      }
    },
    isDisabledRol() {
      if (this.tipeView == "consulta" || this.tipeView == "modificar") {
        return true;
      }
    },
    disableonmodifica() {
      if (this.tipeView == "modifica") {
        return true;
      }
    },
  },
  methods: {
    checkUsername() {
      // console.log("st::this.checkUsername1:" + this.username + "::" + this.idContrato);
      if (
        this.username !== undefined &&
        this.username != null &&
        this.username != ""
      ) {
        // &&
        //    this.idContrato !== undefined && this.idContrato != null && this.idContrato > 0) {
        // console.log("st::this.checkUsername2:" + this.username + "::" + this.idContrato);
        axios
          .get("/userEmail/" + this.username)
          .then((response) => {
            if (!response.data.code || response.data.code === "undefined") {
              this.usuario = response.data;
              this.nombre = this.usuario.nombre;
              this.apellido = this.usuario.apellido;
              this.rut = this.usuario.rut;
              // console.log("st::this.usuario:" + JSON.stringify(this.usuario, null, 2));

              if (response.data.lstUsuContratoRol.length > 0) {
                this.hasContrato(response.data.lstUsuContratoRol);
              }
            }
          })
          .catch((error) => {
            this.existEnContrato = false;
            console.log("checkUsername:" + error);
            this.loading = false;
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          });
      }
    },

    async loadUsuarioData() {
      if (this.tipoUsuarioValue == this.tipoUsuarioProveedor) {
        return await axios
          .get("/userRUT/" + this.rut)
          .then((response) => {
             console.log("loadUsuarioData: user:" + response.data);
            return response.data;
          })
          .catch(function (error) {
            console.log("loadUsuarioData error:" + error);
          });
      } else {
        return await axios
          .get("/user/buscaUser/" + this.username)
          .then((response) => {
             console.log("loadUsuarioData: user:" + response.data);
            return response.data;
          })
          .catch(function (error) {
            console.log("loadUsuarioData error:" + error);
          });
      }
    },

    async loadData() {
      this.usuario = await this.loadUsuarioData();
      if (!this.usuario) {
        this.id = 0;
        this.nombre = "";
        this.rut = "";
        this.apellido = "";
        this.tipoUsuarioValue = -1;
        this.rolUsuarioValue = -1;
        this.idContrato = -1;
        this.contratoSelect = [];
        return;
      }

      this.id = this.usuario.id;
      this.nombre = this.usuario.nombre;
      this.rut = this.usuario.rut;
      this.apellido = this.usuario.apellido;
      if (this.usuario.tipo == "AGENCIA") {
        this.tipoUsuarioValue = 0;
      } else if (this.usuario.tipo == "PROVEEDOR") {
        this.tipoUsuarioValue = 1;
      } else {
        this.tipoUsuarioValue = 2;
      }
      // this.periodo = this.usuario.periodo;
      console.log("stringify:" + JSON.stringify(this.usuario, null, 2));
      if (
        this.usuario.lstUsuContratoRol &&
        this.usuario.lstUsuContratoRol.length
      ) {
        let rolesUsuario = this.getRol(this.usuario.lstUsuContratoRol);
        if (this.usuario.perfil != null) {
          
          this.rolUsuarioValue = this.usuario.perfil.id;

          this.idContrato = Object.keys(rolesUsuario[0])[0];
          this.contratoSelect = [
            {
              id: Object.keys(rolesUsuario[0])[0],
              codigo: Object.keys(this.usuario.lstUsuContratoRol[0])[0],
            },
          ];
        }
      }
      this.loadRoles();
    },

    async loadRoldata() {
      return await axios
        .get("/roles/perfil/" + this.tipoUsuarioValue)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log("loadRoldata: error:" + error);
          return [];
        });
    },

    async loadRoles() {
      if (this.tipoUsuarioValue != null && this.tipoUsuarioValue >= 0) {
        let lista = await this.loadRoldata();
        let arreglo = [];
        lista.forEach(function (d) {
          arreglo.push({ nombre: d.nombre, id: d.id });
        });
        this.rolUsuarioSelect = arreglo;
      } else {
        this.rolUsuarioSelect = [];
      }
      this.rolUsuario = -1;
    },

    async loadPeriodosData() {
      return await axios
        .get("/getAllPeriodos")
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          } else {
            console.log("error loadPeriodosData");
          }
          return [];
        });
    },
    async loadPeriodos() {
      this.periodoSelect = await this.loadPeriodosData();
    },

    async loadContratosData() {
      return await axios
        .get("/getAllContratosByPeriodo/" + this.periodo)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          } else {
            console.log("error loadPeriodosData");
          }
          return [];
        });
    },
    async loadContratos() {
      if (this.periodo && this.periodo > 0) {
        this.contratoSelect = await this.loadContratosData();
      } else {
        this.contratoSelect = [];
        this.idContrato = null;
      }
    },

    back() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },

    save() {
      this.$v.$touch();
      let rutOk = this.validacionRut();
      // consoles.log("rutOk:" + rutOk + "::" + this.rut);
      // console.log("st::detalle:" + this.$v.$invalid + "::" + JSON.stringify(this.$v, null, 2));
      if (!this.$v.$invalid && !this.existEnContrato && rutOk) {
        if (this.tipeView == "crear") {
          this.saveUser();
        } else {
          this.editUser();
        }
      }
    },
    validacionRut() {
      this.rutErrors = [];
      if (
        this.tipoUsuarioValue == this.tipoUsuarioProveedor &&
        this.rut == ""
      ) {
        this.rutErrors.push("RUT es obligatorio.");
        return false;
      }
      if (this.rut != null && this.rut.trim().length > 0) {
        this.rut = this.rut.toUpperCase();
        if (!this.validaRut(this.rut)) {
          this.rutErrors.push("RUT inválido.");
          return false;
        } else if (this.rut.length > 11) {
          this.rutErrors.push("El RUT debe tener como máximo 11 caracteres.");
          return false;
        }
      }
      return true;
    },
    validaRut(rut) {
      // Verificar si el RUT tiene el formato correcto
      if (!/^[0-9]+-[0-9kK]{1}$/.test(rut)) {
        return false;
      }

      let rutNumero = rut.split("-")[0];
      const rutDV = rut.split("-")[1];

      if (rutNumero.length < 7 || rutNumero.length > 9) {
        return false;
      }

      // Validar que el dígito verificador sea correcto
      let suma = 0;
      let multiplicador = 2;
      for (let i = rutNumero.length - 1; i >= 0; i--) {
        suma += parseInt(rutNumero.charAt(i)) * multiplicador;
        multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
      }
      const dvEsperado = 11 - (suma % 11);
      const dvCalculado =
        dvEsperado === 11
          ? "0"
          : dvEsperado === 10
          ? "K"
          : dvEsperado.toString();
      if (dvCalculado !== rutDV && !(dvCalculado === "0" && rutDV === "K")) {
        return false;
      }

      return true;
    },
    saveUser() {
      this.loading = true;
      this.body = {
        username: this.username,
        nombre: this.nombre,
        rut: this.rut != null ? this.rut.trim() : "",
        apellido: this.apellido,
        tipo: this.tipoUsuarioValue,
        idRol: this.rolUsuarioValue,
        idContrato: this.idContrato,
      };
      axios
        .post("/user/crear/usercontrato", this.body)
        .then((response) => {
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },

    editUser() {
      this.loading = true;
      this.body = {
        nombre: this.nombre,
        apellido: this.apellido,
        tipo: this.tipoUsuarioValue,
        idRol: this.rolUsuarioValue,
        idContrato: this.idContrato,
        rut: this.rut != null ? this.rut.trim() : "",
      };
      axios
        .put("/user/editar/usercontrato/" + this.id, this.body)
        .then((response) => {
          this.loading = false;
          window.getApp.$emit("APP_UPDATE");
          this.back();
        })
        .catch((error) => {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          this.loading = false;
        });
    },
    //this is a map
    hasContrato(mapContrato) {
      for (const prop in mapContrato[0]) {
        if (mapContrato[0].hasOwnProperty(prop)) {
          this.existEnContrato = true;
        }
      }
    },
  },
};

var Fn = {
  // Valida el rut con su cadena completa "XXXXXXXX-X"
  validaRut: function (rutCompleto) {
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
    var tmp = rutCompleto.split("-");
    var digv = tmp[1];
    var rut = tmp[0];
    if (digv == "K") digv = "k";
    return Fn.dv(rut) == digv;
  },
  dv: function (T) {
    var M = 0,
      S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    return S ? S - 1 : "k";
  },
};
</script>
